export type DateInputType = 'dateFrom' | 'dateTo';

export const DEFAULT_FORMAT = 'DD-MM-YYYY';
